var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_945_1025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80852 25.375C19.372 25.375 25.1513 16.6212 25.1513 9.03223C25.1513 8.78614 25.1459 8.53458 25.1349 8.28848C26.2592 7.47543 27.2294 6.46836 28 5.31458C26.9529 5.78043 25.8412 6.08467 24.7029 6.21692C25.9015 5.49845 26.799 4.36978 27.2289 3.04012C26.1013 3.70838 24.8682 4.17977 23.5823 4.43411C22.716 3.51355 21.5705 2.90403 20.323 2.69979C19.0754 2.49554 17.7954 2.70795 16.6807 3.30417C15.566 3.90039 14.6788 4.84722 14.1562 5.99826C13.6335 7.1493 13.5047 8.44044 13.7895 9.67208C11.5062 9.5575 9.27259 8.96438 7.23331 7.93118C5.19403 6.89797 3.39464 5.44774 1.9518 3.6745C1.21847 4.93885 0.994066 6.43498 1.3242 7.85883C1.65434 9.28269 2.51424 10.5274 3.72914 11.34C2.81707 11.3111 1.92497 11.0655 1.12656 10.6236V10.6947C1.12575 12.0216 1.58445 13.3077 2.42469 14.3346C3.26494 15.3615 4.43488 16.0657 5.73562 16.3275C4.89073 16.5587 4.00398 16.5924 3.14398 16.426C3.51103 17.5671 4.22517 18.5651 5.18673 19.2808C6.1483 19.9965 7.30931 20.3941 8.50773 20.4182C6.47316 22.0164 3.95987 22.8832 1.37266 22.8791C0.913835 22.8784 0.455466 22.8503 0 22.7949C2.62833 24.4811 5.68579 25.3767 8.80852 25.375Z",
    fill: "#747474"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_1025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.47f8e0cf.svg";
export { ForwardRef as ReactComponent };